module.exports = __webpack_public_path__ + "static/media/youtube.8a32168e742553954edc94bc94c6d09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/youtube.png
// module id = 2651
// module chunks = 1